module.exports = __webpack_public_path__ + "img/faw_thumbnail.09aa3524.png";